<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ ModalTitle }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClick()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-add-edit-employee [emp]="emp" *ngIf="ActivateAddEditEmp">
                </app-add-edit-employee>
            </div>
        </div>
    </div>
</div>

<div class="col-md-12">
    <div class="card" style="border-radius: 0.5rem">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="container-fluid my-4">

                        <div class="card-title">View/Manage Employees and their Attendances</div>
                        <button type="button" class="btn btn-outline-success float-right mb-3" data-toggle="modal"
                            data-target="#exampleModalCenter" (click)="AddClick()" data-backdrop="static"
                            data-keyboard="false">
                            <i class="fas fa-user-plus"></i>
                            | Add Employee
                        </button>

                        <div class="w-100 scroll">
                            <table class="table table-hover table-striped">
                                <thead class="thead-dark">
                                    <tr>
                                        <th class="sticky-row first-row">Emp Name</th>
                                        <th class="sticky-row first-row">Emp Email</th>
                                        <th class="sticky-row first-row">Designation</th>
                                        <th class="sticky-row first-row">Contact Number</th>
                                        <th class="text-right sticky-row first-row">Casual LB</th>
                                        <th class="text-right sticky-row first-row">Annual LB</th>
                                        <th class="sticky-row first-row">Options</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let DataItem of employeeList">
                                        <td>{{ DataItem.FirstName + " " + DataItem.LastName }}</td>
                                        <td>{{ DataItem.EmpEmail }}</td>
                                        <td>{{ DataItem.Designation }}</td>
                                        <td>{{ DataItem.ContactNumber }}</td>
                                        <td class = "text-right">{{ DataItem.CasualLeaveBalance | number: '1.2-2'}}</td>
                                        <td class = "text-right">{{ DataItem.AnnualLeaveBalance | number: '1.2-2'}}</td>
                                        <td>
                                            <div role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-outline-dark mr-1 btn-sm border-0"
                                                    data-toggle="modal" data-target="#exampleModalCenter"
                                                    (click)="EditClick(DataItem)" data-backdrop="static"
                                                    data-keyboard="false" placement="top" ngbTooltip="Edit Employee">
                                                    <i class="fas fa-user-edit"></i>
                                                </button>
                                                <button type="button" class="btn btn-outline-dark mr-1 btn-sm border-0"
                                                    (click)="DeleteClick(DataItem)" data-toggle="tooltip"
                                                    placement="top" ngbTooltip="Delete Employee">
                                                    <i class="fas fa-user-times"></i>
                                                </button>
                                                <button routerLink="attendance-view" type="button"
                                                    class="btn btn-outline-dark mr-1 btn-sm border-0"
                                                    (click)="ViewAttendance(DataItem.pkEmpId)">
                                                    View Attendance
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
